import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
export const DetailsContact = (props: any) => {
  const [serviceLevel, setServiceLevel] = React.useState<string | null>(null);
  const [serviceType, setServiceType] = React.useState<string | null>(null);
  const [deliverables, setDeliverables] = React.useState<string | null>(null);
  const [startDate, setStartDate] = React.useState<string | null>(null);
  const [endDate, setEndDate] = React.useState<string | null>(null);
  const [warrantyType, setWarrantyType] = React.useState<string | null>(null);
  const [referenceNo, setReferenceNo] = React.useState<string | null>(null);
  const [status, setStatus] = React.useState<string | null>(null);
  const {t} = useTranslation();

  React.useEffect(() => {
    if (!props.data || !props.flag || !props.type) return;
    const formatDate = (dateString: string): string => {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    };
    setWarrantyType(props.type);
    for (const value of props.data) {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      const endDateFormatted = formatDate(value.EndDate);

      if (value.EntitlementType.toLowerCase().includes(props.flag)) {
        setReferenceNo(value.ContractEntitlementId || "");
        setStartDate(value.StartDate || "");
        setEndDate(value.EndDate);
        // Generate Service Type
        if (value.Offers && value.Offers.length > 0) {
          const serviceTypeString = value.Offers.map(
            (offer: any) => offer.PackageName
          ).join(" ");
          setServiceType(serviceTypeString);
        }
        if (value.Offers && value.Offers.length > 0) {
          const deliverablesString = value.Offers.flatMap(
            (offer: any) =>
              offer.Delieverables?.map(
                (deliverable: any) => deliverable.DeliverableName
              ) || []
          )
            .filter(Boolean) // Remove any null or undefined values
            .join(" ");
          setDeliverables(deliverablesString);
        }

        if (value.Offers && value.Offers.length > 0) {
          const serviceLevelString = value.Offers.flatMap(
            (offer: any) =>
              offer.Modifiers?.map(
                (modifier: any) => modifier.ModifierDescription
              ) || []
          )
            //.filter(Boolean) // Remove any null or undefined values
            .join(" ");
          setServiceLevel(serviceLevelString);
        }
        // Generate Status
        if (value.Status) {
          const formattedStatus = value.Status.toLowerCase();
          switch (formattedStatus) {
            case "active":
              setStatus(
                `<span  class="spnActive text-success"> <strong>${value.Status} : </strong>Covered under contract, Expiration date:  <strong>${endDateFormatted} </strong> </span>`
              );
              break;
            case "expired":
              setStatus(
                `<span class="spnExpired text-danger"> <strong>${value.Status} </strong>Covered under contract, Expiration date : <strong> ${endDateFormatted} </strong></span>`
              );
              break;
            case "pending":
              setStatus("Pending");
              break;
            default:
              setStatus("Unspecified");
          }
        }
        break; // Exit the loop once the matching entitlement type is found
      }
    }
  }, [props.data || props.flag || props.type]);

   //const cleanedHtmlString = htmlString.replace(/<br\s*\/?>/gi, '');

  return (
    <div className="contract-details">


      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.productdetails.Warrantytype',{defaultValue:'Warranty type'})}</label>
          </Col>
          <Col sm={8}>
            <p className="body-regular">{warrantyType}</p>
          </Col>
        </Row>
      </div>

      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.Warranty.Referencenumber',{defaultValue:'Reference number'})}</label>
          </Col>
          <Col sm={8}>
            <p className="body-regular">{referenceNo}</p>
          </Col>
        </Row>
      </div>

      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.productdetails.Servicetype',{defaultValue:'Service type'})}</label>
          </Col>
          <Col sm={8}>
            <div
              className="body-regular"
              dangerouslySetInnerHTML={{ __html: serviceType || "" }}
            >
            
            </div>
          </Col>
        </Row>
      </div>

      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.productdetails.Status',{defaultValue:'Status'})}</label>
          </Col>
          <Col sm={8}>
          <p
              className="body-regular"
              dangerouslySetInnerHTML={{ __html: status || "" }}
            />
          </Col>
        </Row>
      </div>

      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.productdetails.StartDate',{defaultValue:'Start date'})}</label>
          </Col>
          <Col sm={8}>{startDate}</Col>
        </Row>
      </div>
      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Entitlement.EntitleDetails.Enddate',{defaultValue:'End date'})}</label>
          </Col>
          <Col sm={8}>{endDate}</Col>
        </Row>
      </div>
      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.productdetails.Servicelevel',{defaultValue:'Service level'})}</label>
          </Col>
          <Col sm={8}>{<div dangerouslySetInnerHTML={{ __html: serviceLevel || "" }} />}</Col>
        </Row>
      </div>
      <div className="info-wrapper">
        <Row>
          <Col sm={3}>
            <label className="label-regular">{t('HPI.Product.productdetails.Deliverables',{defaultValue:'Deliverables'})}</label>
          </Col>
          <Col sm={8}>{<div dangerouslySetInnerHTML={{ __html: deliverables || "" }} />}</Col>
        </Row>
      </div>
    </div>
  );
};
